import type { Resource } from '../../';
export const product_sizeChart_ages_toddlers: Resource = {"default":"1.5 - 5 Years"};
